import { Component, OnInit } from '@angular/core';
import { DataTransfer, PublicisAudience, PublicisTransfer, PublicisTransferFile, PublicisTransferFileTimeSent } from 'src/app/models/services/admin/dataTransferInfo';
import { IdentifiersTypes } from 'src/app/models/services/identifiersTypes.enum';
import { AudiencesService } from 'src/app/services/audiences/audiences.service';

@Component({
  selector: 'app-data-transfer-info-dialog',
  templateUrl: './data-transfer-info-dialog.component.html',
  styleUrls: ['./data-transfer-info-dialog.component.sass']
})
export class DataTransferInfoDialogComponent implements OnInit {
  public dismiss: () => void;
  public dataTransfer: DataTransfer;

  title: string = "Data transfer info"; 

  private flatten = (x) => x.reduce((a, b) => a.concat(Array.isArray(b) ? this.flatten(b) : b), []);

  constructor(private audiencesService: AudiencesService) { }

  ngOnInit(): void {
  }

  getSentHistory = (dataTransfer: DataTransfer): PublicisTransferFileTimeSent[] => {
    if(dataTransfer.transfers.length == 0)
      return [];

    let result: PublicisTransferFileTimeSent[] = this.flatten(this.flatten(dataTransfer.transfers).map(x => x.files)).map(x => x.timesSent);
    return result.sort();
  }

  getUniqueAudiences = (dataTransfer: DataTransfer): PublicisAudience[] => {
    if(dataTransfer.transfers?.length == 0)
      return [];

    let result: PublicisAudience[] = dataTransfer.transfers.map(x => x.audience);
    return this.uniqBy(result, JSON.stringify).sort((x: PublicisAudience, y: PublicisAudience) => x.id - y.id);
  }

  uniqBy = (a: any, key: any) => {
    var seen = {};
    return a.filter((item) => {
        var k = key(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    })
  }  

}


